export default class BaseAccordion {
    panelOpen = false;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('Accordion', () => new BaseAccordion());
});
